import {RootState} from '../store';

export const areSuggestionsLoadingSelector = (state: RootState) => state.suggestions.isLoading;
export const suggestionsSelector = (state: RootState) => state.suggestions.items;
